import { render, staticRenderFns } from "./project-card-grid.vue?vue&type=template&id=33b2dd43&scoped=true"
import script from "./project-card-grid.vue?vue&type=script&lang=js"
export * from "./project-card-grid.vue?vue&type=script&lang=js"
import style0 from "./project-card-grid.vue?vue&type=style&index=0&id=33b2dd43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2dd43",
  null
  
)

export default component.exports